import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import { MapComponentProps } from './map';
import { ControlPosition, getControlPosition } from './util';

interface ControlProps extends MapComponentProps {
    position: ControlPosition;
    content: (() => React.ReactNode) | React.ReactNode;
}

export class Control extends React.PureComponent<ControlProps> {

    static propTypes = {
        //TODO: MapComponentProps
        position: PropTypes.oneOf([
            ControlPosition.TOP_LEFT, ControlPosition.TOP_CENTER, ControlPosition.TOP_RIGHT,
            ControlPosition.LEFT_BOTTOM, ControlPosition.LEFT_CENTER, ControlPosition.LEFT_TOP,
            ControlPosition.RIGHT_BOTTOM, ControlPosition.RIGHT_CENTER, ControlPosition.RIGHT_TOP,
            ControlPosition.BOTTOM_LEFT, ControlPosition.BOTTOM_CENTER, ControlPosition.BOTTOM_RIGHT
        ]).isRequired,
        content: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired
    }

    static displayName: "GoogleMaps.Control";

    private readonly div: HTMLDivElement = document.createElement('div');

    componentDidMount() {
        this.props.map.controls[getControlPosition(this.props.position)].push(this.div);
    }

    componentDidUpdate(prevProps: ControlProps) {
        let prevPosition = getControlPosition(prevProps.position);
        let position = getControlPosition(this.props.position);

        if (position !== prevPosition) {
            let map = this.props.map;
            let oldIndex = map.controls[prevPosition].getArray().indexOf(this.div);
            if (oldIndex >= 0)
                map.controls[prevPosition].removeAt(oldIndex);
            this.props.map.controls[getControlPosition(this.props.position)].push(this.div);
        }
    }

    render() {
        const content = this.props.content instanceof Function ? this.props.content() : this.props.content;
        return ReactDOM.createPortal(content, this.div);
    }
}
